// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1UVyY","title":"ClientInsurance_title__1gGTA","itemText":"ClientInsurance_itemText__oJOAz"};